import baseForOwnRight from './_baseForOwnRight.js';
import createBaseEach from './_createBaseEach.js';

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

export default baseEachRight;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseEachRight.js
// module id = 1055
// module chunks = 67